// Translation for en
export const ml = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'ചാറ്റ് സേവനം നിലവിൽ ലഭ്യമല്ല. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'പാഠ്യപദ്ധതി',
                buttonTitle: 'പാഠ്യപദ്ധതി ഉള്ളടക്കം കാണിക്കുക',
                modalTitle: '{app} പാഠ്യപദ്ധതി',
                sections: {
                    topic: 'പാഠ്യപദ്ധതി വിഷയം',
                    explanation: 'കുട്ടികൾക്ക് മനസ്സിലാകുന്ന വിശദീകരണം',
                    studentProfile: 'വിദ്യാർത്ഥി പ്രൊഫൈൽ'
                },
                topic: {
                    empty: 'ഈ മൈക്രോ-ആപ്പുമായി ബന്ധപ്പെട്ട പാഠ്യപദ്ധതി വിഷയം ബാക്കെൻഡിൽ ഇല്ല.',
                    missingDetail: 'ഈ മൈക്രോ-ആപ്പിനുള്ള വിശദമായ പാഠ്യപദ്ധതി ഡാറ്റ ബാക്കെൻഡിൽ ഇതുവരെ ലഭ്യമല്ല.',
                    learningGoals: 'പഠന ലക്ഷ്യങ്ങൾ',
                    prerequisites: 'മുൻവ്യവസ്ഥകൾ',
                    unitLabel: 'യൂണിറ്റ്',
                    durationLabel: 'ദൈർഘ്യം',
                    difficultyLabel: 'ബുദ്ധിമുട്ട് നില',
                    hours: 'മണിക്കൂർ',
                    minutes: 'മിനിറ്റ്'
                },
                explanation: {
                    empty: 'കുട്ടികൾക്ക് മനസ്സിലാകുന്ന വിശദീകരണം ലഭ്യമല്ല.',
                    loadingPrepare: 'AI വിശദീകരണം തയ്യാറാക്കുന്നു',
                    loadingExplain: 'AI കുട്ടികൾക്ക് മനസ്സിലാകുന്ന ഭാഷയിൽ വിഷയം വിശദീകരിക്കുന്നു',
                    requestFailed: 'കുട്ടികൾക്ക് മനസ്സിലാകുന്ന വിശദീകരണം സൃഷ്ടിക്കാൻ കഴിഞ്ഞില്ല.'
                },
                studentProfile: {
                    country: 'രാജ്യം',
                    region: 'സംസ്ഥാനം / മേഖല',
                    schoolType: 'സ്കൂൾ തരം',
                    grade: 'ഗ്രേഡ്',
                    noContext: 'വിദ്യാർത്ഥി സന്ദർഭം ലഭ്യമല്ല.',
                    childProfileNotFound: 'നിലവിലെ ലോഗിനിനായി ബാക്കെൻഡിൽ വിദ്യാർത്ഥി പ്രൊഫൈൽ കണ്ടെത്തിയില്ല.',
                    loginProfileIncomplete: 'ലോഗിൻ പ്രൊഫൈലിൽ ഇതുവരെ പൂർണ്ണമായ വിദ്യാർത്ഥി സന്ദർഭം ഇല്ല.',
                    educationContextNotFound: 'വിദ്യാർത്ഥി പ്രൊഫൈൽ കണ്ടെത്തി, എന്നാൽ പാഠ്യപദ്ധതി അസൈൻമെന്റ് സജ്ജീകരിച്ചിട്ടില്ല.',
                    noToken: 'സൈൻ ഇൻ ചെയ്ത വിദ്യാർത്ഥിയെ കണ്ടെത്തിയില്ല.'
                },
                errors: {
                    signInRequired: 'പാഠ്യപദ്ധതി കാണുന്നതിന് ദയവായി സൈൻ ഇൻ ചെയ്യുക.',
                    appIdMissing: 'ആപ്പ് ഐഡി ഇല്ല.',
                    loadFailed: 'പാഠ്യപദ്ധതി ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല.'
                }
            }
    };
